// import './Themes/global.scss'
import Header from './Components/templates/Header'
import Footer from './Components/templates/Footer'
import { Survey } from './Components/organisms/Survey/survey'
// import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { useGlobalCtx } from './Context/GlobalContext'
import { SurveyContextProvider } from './Context/SurveyContext'
import { RecruitContextProvider } from './Context/RecruitContext'
import { BlockContextProvider } from './Context/BlockContext'
import PostSurvey from './Components/organisms/PostSurvey/PostSurvey'
import { ThemeSelector } from './Components/templates/Theme/ThemeSelector'

function App() {
  const globalCtx = useGlobalCtx()

  return (
    
      <SurveyContextProvider>
        <BlockContextProvider>
          <RecruitContextProvider>
            <ThemeSelector>
              <div className="theme-page-container">
                <header id="theme-page-header" className={globalCtx.dir === "rtl" ? "theme-page-header rtl" : "theme-page-header"}>
                  <Header />
                </header>
                {/* <main id="theme-page-main" className="theme-page-main w-11/12 2xl:w-6/12 xl:w-7/12 lg:w-8/12 md:w-10/12"> */}
                <main id="theme-page-main" className={globalCtx.dir === "rtl" ? "theme-page-main rtl" : "theme-page-main"}>
                  {globalCtx.PostSurvey === false && <Survey/>}
                  {globalCtx.PostSurvey === true && <PostSurvey />}
                </main>
                <footer id="theme-page-footer" className={globalCtx.dir === "rtl" ? "theme-page-footer rtl" : "theme-page-footer"}>
                  <Footer />
                </footer>
              </div>
            </ThemeSelector>
          </RecruitContextProvider>
        </BlockContextProvider>
      </SurveyContextProvider>
    
  )
}

export default App